import React from "react";
import {
  TextField,
  FormControlLabel,
  Divider,
  Radio,
  Button,
  Box,
} from "@mui/material";
import { Film, Clock, Maximize2, Delete, Download } from "react-feather";

const styles = {
  select: {
    "& .MuiOutlinedInput-notchedOutline": { border: "none" },
    "& .MuiOutlinedInput-root": {
      borderRadius: "12px",
      backgroundColor: "#f9f9f9",
    },
    "& .MuiInputLabel-root": { color: "#555" },
    "&.Mui-disabled .MuiOutlinedInput-root": { backgroundColor: "#f0f0f0" },
  },
};

export default function VideoGeneralTab({
  videoTitle,
  setVideoTitle,
  videoFile,
  videoDuration,
  isLandscape,
  setIsLandscape,
  isSubmitting,
  preview,
  onDelete,
  onDownload,
  isDeleting,
  isDownloading,
}) {
  return (
    <>
      <h1 className="add-video-title">Selecteaza un spot</h1>
      <Divider style={{ marginBottom: "20px" }} />
      <div
        style={{
          display: "flex",
          columnGap: "7px",
          alignItems: "center",
        }}
      >
        <Film fontSize={"1rem"} />
        <span style={{ fontSize: "1rem", color: "red" }}>Titlu</span>
      </div>
      <TextField
        label="Titlu"
        fullWidth
        variant="outlined"
        value={videoTitle}
        disabled={preview}
        onChange={(e) => setVideoTitle(e.target.value)}
        className="add-video-field"
        sx={styles.select}
      />

      <Divider />
      <div
        style={{
          display: "flex",
          columnGap: "10px",
          alignItems: "center",
        }}
      >
        <Clock fontSize={"1rem"} />
        <span style={{ fontSize: "1rem", color: "red" }}>Durata (secunde)</span>
      </div>
      <TextField
        label="Durata (secunde)"
        type="number"
        disabled
        fullWidth
        variant="outlined"
        value={videoDuration}
        className="add-video-field"
        sx={styles.select}
      />
      <Divider />
      <div
        style={{
          display: "flex",
          columnGap: "10px",
          alignItems: "center",
        }}
      >
        <Maximize2 fontSize={"1rem"} />
        <span style={{ fontSize: "1rem" }}>Orientare</span>
      </div>
      <div className="orientation-options">
        {/* TODO: pentru urmatoarele module se va activa functionalitatea de orientare a videoclipului */}
        <FormControlLabel
          control={
            <Radio
              disabled={true}
              checked={isLandscape}
              onChange={() => setIsLandscape(true)}
              color="primary"
            />
          }
          label="Landscape"
        />
        <FormControlLabel
          control={
            <Radio
              disabled={true}
              checked={!isLandscape}
              onChange={() => setIsLandscape(false)}
              color="primary"
            />
          }
          label="Portret"
        />
      </div>

      {!preview && (
        <>
          <Divider style={{ margin: "30px 0 20px 0" }} />
          <Box
            style={{
              display: "flex",
              gap: "15px",
              justifyContent: "flex-start",
              alignItems: "center",
            }}
          >
            <Button
              variant="outlined"
              color="primary"
              onClick={onDownload}
              disabled={isDownloading || isSubmitting}
              startIcon={<Download size={18} />}
              style={{
                textTransform: "none",
                borderRadius: "8px",
                padding: "8px 16px",
                fontSize: "14px",
              }}
            >
              {isDownloading ? "Se descarca..." : "Descarca Spot"}
            </Button>

            <Button
              variant="outlined"
              color="error"
              onClick={onDelete}
              disabled={isDeleting || isSubmitting}
              startIcon={<Delete size={18} />}
              style={{
                textTransform: "none",
                borderRadius: "8px",
                padding: "8px 16px",
                fontSize: "14px",
              }}
            >
              {isDeleting ? "Se sterge..." : "Sterge Spot"}
            </Button>
          </Box>
        </>
      )}
    </>
  );
}
